export default __webpack_public_path__ + "static/media/SIW610_T018_W0.6d4dff7c.webp";